import { Dispatch } from 'react';

import Cookie from 'js-cookie';

import { COOKIE_AST_TOKEN_JS, COOKIE_AST_SIGNUP_SUCCESS } from '../../../../../constants/Common';


import UserService from '../../../../../services/Api/User';
import Url from '../../../../../services/Url';

import { IReducerAction } from '../../../../Hooks/Context/connect';

import { IGradient } from '../../Common/Form/Button';
import { Steps } from '../Constants';
import { IAuthPartialReducer, TAuthPartialState } from './Reducers';

enum Types {
    CHANGE_STEP = 'CONTAINER:CHANGE_STEP',
    HANDLE_ERROR = 'CONTAINER:HANDLE_ERROR',
    BUTTON_LOADING = 'CONTAINER:BUTTON_LOADING',
    PAGARME_CHECKOUT = 'CONTAINER:PAGARME_CHECKOUT',
    HANDLE_USER_DATA = 'CONTAINER:HANDLE_USER_DATA',
    SHOW_PAYMENT_MODAL = 'CONTAINER:SHOW_PAYMENT_MODAL',
    CHANGE_REDIRECT_AUTH = 'CONTAINER:CHANGE_REDIRECT_AUTH',
    CHANGE_COMMUNICATION = 'CONTAINER:CHANGE_COMMUNICATION',
}

interface ICommunication extends Record<string, string> {
    titleLogin: string,
    titleBirthData: string,
    titlePersonalData: string,

    buttonLoginText: string,
    buttonPaymentText: string,
    buttonBirthDataText: string,
    buttonPersonalDataText: string,

    placeholderName: string,
    placeholderEmail: string,
    placeholderGender: string,
    placeholderPassword: string,
    placeholderReference: string,
    placeholderBirthTime: string,
    placeholderBirthDate: string,
    placeholderBirthPlace: string,
}

interface IPagarmeProps {
    amount: string,
    planId: string,
    reference: string,
    showModal: boolean,
    comunication: string,
    urlReference: string,
    renewalPlanId: string,
    pagarmeResponse: any,
}

interface IAuthStateContainer extends TAuthPartialState {
    step: string,
    uuid?: string,
    theme: string,
    origin: string,
    reset: boolean,
    isCloseable: boolean,
    errorMessage: string,
    initialStep: string,
    maintenance: boolean,
    redirectToAuth: number,
    buttonLoading: boolean,
    pagarme: IPagarmeProps,
    showAppButtons: boolean,
    disabledButton: boolean,
    needConversion: boolean,
    containerColor?: string,
    showAstrolinkLogo: boolean,
    buttonGradient?: IGradient,
    keepSubmitEnabled?: boolean,
    customConfiguration?: string,
    listenTo: string | undefined,
    communication: ICommunication,
    oauthShowConsetTerms: boolean,
    i18nPayment: boolean | undefined,
    allowBottomTermsWarning?: boolean,
    isThirdPartyLoginEnabled: boolean,
    isNext?: string,

    user: {
        name: string,
        email: string,
        fullName?: string,
        isSubscriber: string,
        isEmailConfirmed: string,
    },

    i18n: {
        lang: string,
        dateFormat: string,
        useUSFormat: boolean
    }
}

interface IAuthContainerReducer extends IAuthPartialReducer {
    (action: IReducerAction, state: { Container: IAuthStateContainer }): void;
}

const initialState: { Container: IAuthStateContainer } = {
    Container: {
        origin: '',
        reset: false,
        theme: 'light',
        uuid: undefined,
        errorMessage: '',
        redirectToAuth: 0,
        isCloseable: false,
        maintenance: false,
        listenTo: undefined,
        i18nPayment: undefined,
        buttonLoading: false,
        disabledButton: true,
        showAppButtons: false,
        step: Steps.BIRTH_DATA,
        showAstrolinkLogo: true,
        keepSubmitEnabled: false,
        containerColor: undefined,
        buttonGradient: undefined,
        oauthShowConsetTerms: false,
        initialStep: Steps.BIRTH_DATA,
        isThirdPartyLoginEnabled: true,
        customConfiguration: undefined,
        isNext: '',

        user: {
            name: '',
            email: '',
            isSubscriber: '',
            isEmailConfirmed: ''
        },

        needConversion: false,

        communication: {
            titleLogin: '',
            titleBirthData: '',
            titlePersonalData: '',

            buttonLoginText: '',
            buttonPaymentText: '',
            buttonBirthDataText: '',
            buttonPersonalDataText: '',

            placeholderName: '',
            placeholderEmail: '',
            placeholderGender: '',
            placeholderPassword: '',
            placeholderReference: '',
            placeholderBirthTime: '',
            placeholderBirthDate: '',
            placeholderBirthPlace: ''
        },

        pagarme: {
            amount: '',
            planId: '',
            reference: '',
            showModal: false,
            comunication: '',
            renewalPlanId: '',
            pagarmeResponse: null,
            urlReference: Url.base()
        },

        i18n: {
            lang: '',
            dateFormat: '',
            useUSFormat: false
        }
    }
};

const ContainerReducer: IAuthContainerReducer = (action, state = initialState) => {
    switch (action.type) {
        case Types.CHANGE_STEP:
            return {
                ...state,
                Container: {
                    ...state.Container,
                    step: action.data
                }
            };

        case Types.BUTTON_LOADING:
            return {
                ...state,
                Container: {
                    ...state.Container,
                    buttonLoading: action.data
                }
            };

        case Types.HANDLE_ERROR:
            return {
                ...state,
                Container: {
                    ...state.Container,
                    errorMessage: action.data
                }
            };

        case Types.PAGARME_CHECKOUT:
            return {
                ...state,
                Container: {
                    ...state.Container,
                    pagarme: {
                        ...state.Container.pagarme,
                        ...action.data
                    }
                }
            };

        case Types.HANDLE_USER_DATA:
            return {
                ...state,
                Container: {
                    ...state.Container,
                    user: {
                        ...state.Container.user,
                        ...action.data
                    }
                }
            };

        case Types.CHANGE_COMMUNICATION:
            return {
                ...state,
                Container: {
                    ...state.Container,
                    communication: {
                        ...state.Container.communication,
                        ...action.data
                    }
                }
            };

        case Types.SHOW_PAYMENT_MODAL:
            return {
                ...state,
                Container: {
                    ...state.Container,
                    pagarme: {
                        ...state.Container.pagarme,
                        showModal: true
                    }
                }
            };

        case Types.CHANGE_REDIRECT_AUTH:
            return {
                ...state,
                Container: {
                    ...state.Container,
                    redirectToAuth: action.data
                }
            };

        default:
            return state;
    }
};

function multipleActions<T = IReducerAction>(dispatch: Dispatch<T>, actions: T[]) {
    if (!actions) return;

    actions.forEach(action => {
        if (!((action as unknown) as IReducerAction).type) return;
        dispatch(action);
    });
}

const actionRenderPayment = async (dispatch: Dispatch<IReducerAction>, token: string, urlReference?: string) => {
    Cookie.set(COOKIE_AST_TOKEN_JS, token, {
        expires: 365
    });

    const $UserService = new UserService();

    if (!$UserService.token) $UserService.token = token;

    try {
        const { user } = await $UserService.getUser();

        if (urlReference && user && user.usu_assinante === 'S') {
            Url.location(urlReference);
            return;
        }

        const names = user.usu_nome.split(' ');
        const name = names.length > 1 ? names.slice(0, -1).join(' ') : names[0];

        multipleActions(dispatch, [
            {
                type: Types.HANDLE_USER_DATA,
                data: {
                    name,
                    email: user.usu_email,
                    fullName: user.usu_nome,
                    isSubscriber: user.usu_assinante === 'S',
                    isEmailConfirmed: user.usu_email_confirmado === 'S'
                }
            },
            {
                type: Types.CHANGE_STEP,
                data: Steps.PAYMENT
            }
        ]);
    } catch (error) {
        console.error(error);
    }
};

const actionReturnStep = (dispatch: Dispatch<IReducerAction>, step?: string) => dispatch({
    type: Types.CHANGE_STEP,
    data: (() => {
        if (step === Steps.PERSONAL_DATA) {
            return Steps.BIRTH_DATA;
        }

        return Steps.BIRTH_DATA;
    })()
});

const actionRedirectAuth = (astToken: string) => {
    Cookie.set(COOKIE_AST_SIGNUP_SUCCESS, '1');

    // @ts-ignore
    let redirectRoute = Url.getParameterByName('refer') || '';

    try {
        const metaRedirectElement = (document.getElementsByName('auth-redirect-route')[0] || {}) as HTMLMetaElement;
        redirectRoute = metaRedirectElement.content || redirectRoute;
    } catch (err) {
        console.error('Error on get redirect route: ', err);
    }

    const params = {
        ast_token: astToken,
        redirect_to: redirectRoute || ''
    };

    const url = Url.base(`auth/validate${Url.queryParams(params)}`);
    Url.location(url);
};

export {
    initialState,
    multipleActions,
    actionRenderPayment,
    actionReturnStep,
    actionRedirectAuth,

    Types,
    IPagarmeProps,
    ICommunication,
    IAuthStateContainer,
    IAuthContainerReducer
};

export default ContainerReducer;
